import { render } from "./DefaultMailNewInvoice.vue?vue&type=template&id=3a8ec636"
import script from "./DefaultMailNewInvoice.vue?vue&type=script&lang=js"
export * from "./DefaultMailNewInvoice.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__